<script>
  export default {
    name: 'search-box',
    computed: {
      q: {
        get: function () {
          return this.$store.state.q
        },
        set: function (q) {
          this.$store.commit('mUpdateQ', q)
          this.$emit('input', q)
        }
      }
    }
  }
</script>

<template>
  <div>
    <el-input
      autofocus
      placeholder="Wpisz fragment nazwy szukanego produktu"
      prefix-icon="el-icon-search"
      type="text"
      :clearable="true"
      v-model="q"
    ></el-input>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/search-box.vue